import React from 'react'
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import img1 from "../assests/dummy-img1.jpg";
import img2 from "../assests/dummy-img2.jpg";
// import img3 from "../assests/clientle/go-auto.png";

const responsive = {
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 2,
    slidesToSlide: 1, // optional, default to 1.
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 1,
    slidesToSlide: 1, // optional, default to 1.
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1,
    slidesToSlide: 1, // optional, default to 1.
  },
};

const ClientReview = () => {
  return (
    <>
      <section className="startup-reviews u-pb-40">
        <div className="container">
          <div className="row">
            <div className="col-12 text-center">
              <h2 className="h1 text-white">Client Opinions & Reviews</h2>
              <div className="u-h-4 u-w-50 bg-white rounded mt-4 u-mb-30 mx-auto"></div>
            </div>
          </div>
          <Carousel
            swipeable={true}
            draggable={true}
            showDots={responsive.mobile ? true : false}
            responsive={responsive}
            // ssr={true} // means to render carousel on server-side.
            infinite={true}
            autoPlay={true}
            autoPlaySpeed={5000}
            // keyBoardControl={true}
            customTransition="linear 0.8s"
            // transitionDuration={500}
            containerclassNameName="carousel-container"
            removeArrowOnDeviceType={["tablet", "mobile"]}
            // deviceType={this.props.deviceType}
            dotListclassNameName="custom-dot-list-style"
            itemclassNameName="carousel-item-padding-200-px"
          >
            <div className="p-5 rounded bg-white text-center box-shadow-v2 m-4">
              <img
                className="rounded-circle mx-auto mb-4 u-w-100"
                src={img1}
                alt="reviwer image"
              />
              <h4>Nikunj Jain</h4>
              <p className="text-muted">Review on Google Business</p>
              <p>
                Good place to have meetings and all. Well designed which
                provides great convenience. Also has good parking facilities.
              </p>
            </div>
            <div className="p-5 rounded bg-white text-center box-shadow-v2 m-4">
              <img
                className="rounded-circle mx-auto mb-4 u-w-100"
                src={img2}
                alt="reviewer image"
              />
              <h4>Namrata Sahu</h4>
              <p className="text-muted">Review on Google Business</p>
              <p>
                If you want to save more and skip the huge office rent expenses,
                you can book your space at Premisin now. They’re the best when
                it comes to sharing workspaces.
              </p>
            </div>
            <div className="p-5 rounded bg-white text-center box-shadow-v2 m-4">
              <img
                className="rounded-circle mx-auto mb-4 u-w-100"
                src={img1}
                alt=""
              />
              <h4>Gaurav Chandrakar</h4>
              <p className="text-muted">Review on Google Business</p>
              <p>
                I've visited many places but this place is best as compared to
                others for meetings and conferences. You should also try it.
              </p>
            </div>
            <div className="p-5 rounded bg-white text-center box-shadow-v2 my-4">
              <img
                className="rounded-circle mx-auto mb-4 u-w-100"
                src={img2}
                alt=""
              />
              <h4>Vignesh Jeyachandran</h4>
              <p className="text-muted">Review on Google Business</p>
              <p>
                Best co worker space in raipur. All facilities provided, highly
                recommend..
              </p>
            </div>
            <div className="p-5 rounded bg-white text-center box-shadow-v2 m-4">
              <img
                className="rounded-circle mx-auto mb-4 u-w-100"
                src={img1}
                alt=""
              />
              <h4>Phalguni Sarkar</h4>
              <p className="text-muted">Review on Google Business</p>
              <p>
                The 12 hours access of office spaces by Premisin is a great
                thing and we loved the workplace. Hope to be there again soon.
              </p>
            </div>
            <div className="p-5 rounded bg-white text-center box-shadow-v2 m-4">
              <img
                className="rounded-circle mx-auto mb-4 u-w-100"
                src={img2}
                alt=""
              />
              <h4>Ashish Bajaj</h4>
              <p className="text-muted">Review on Google Business</p>
              <p>
                Visit their office, you'll surely love it. A great place to
                work. Neat, well furnished, and peaceful so as to stimulate the
                flow of creativity.
              </p>
            </div>
          </Carousel>
        </div>
      </section>
    </>
  );
}

export default ClientReview